import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  voteQuestion: {
    method: 'POST',
    url: `${configs.baseUrl}/api/question/vote/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const voteQuestion = async (params) => {
  const res = await resource.voteQuestion(params)
  return res.body
}

export default {
  initResource,
  voteQuestion,
}
